import { render, staticRenderFns } from "./design_mode.vue?vue&type=template&id=f8cf8d4a&scoped=true"
import script from "./design_mode.vue?vue&type=script&lang=js"
export * from "./design_mode.vue?vue&type=script&lang=js"
import style0 from "./design_mode.vue?vue&type=style&index=0&id=f8cf8d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cf8d4a",
  null
  
)

export default component.exports